import { useAuth0 } from '@auth0/auth0-react';
import { Loader } from '@bordrio/ui-components';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { logError } from '@src/services/error-logger';
import { getAuth0Locale } from '@src/utils/auth0';

interface Props {
  children: JSX.Element;
}

// we can't use the provided withAuthenticationRequired because we can
// only provide the ui_locales option on initialization rather than render

function RequireAuth({ children }: Props): JSX.Element {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const { i18n } = useTranslation();

  const { language } = i18n;

  useEffect(() => {
    if (isLoading || isAuthenticated) {
      return;
    }
    const options = {
      ui_locales: getAuth0Locale(language),
      appState: {
        returnTo: `${window.location.pathname}${window.location.search}`,
      },
    };
    loginWithRedirect(options).catch((err) => logError(err));
  }, [isLoading, isAuthenticated, loginWithRedirect, language]);

  if (!isAuthenticated) {
    return <Loader />;
  }

  return children;
}

export default RequireAuth;
